"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriterPlacement = void 0;
var WriterPlacement;
(function (WriterPlacement) {
    WriterPlacement["WriterTop"] = "my_works_top";
})(WriterPlacement = exports.WriterPlacement || (exports.WriterPlacement = {}));
